export default __webpack_public_path__ + "static/media/update.d7ca54a9.svg";